import React from "react";
import {
  Container,
  Title,
  Header,
  HeaderTitle,
  HeaderIconLeft,
  HeaderIconRight,
  TableContainer,
  TableHeader,
  TableBody,
} from "../Component/TableComponent/Table";
import InputSearch from "../Component/Search/Search";
import PickColumn from "../Component/PickColumn/PickColumn";
import Action from "../Component/Action/Action";
import AddGroup from "../Component/AddGroup/AddGroup";
import CreatedOn from "../Component/CreatedOn/CreatedOn";
import Filter from "../Component/Filter/Filter";
import { osplist } from "../Component/Utils/Utils";
import Trendingproduct from "./Trendingproduct";

function Trending_Products() {
  return (
    <div className="mt-10">
      <p className="font-semibold text-gray-500 text-xl mb-2">
        Manage Trending Products
      </p>
      <p className="text-sm font-inter  mb-2">
        You Can manage All Website "
        <span className="text-red-600">Trending Products</span>" Here
      </p>
      <div className="flex justify-center rounded-xl border my-5 items-center border-gray-300">
        <Trendingproduct />
      </div>
      <Trending_Table />
    </div>
  );
}

export default Trending_Products;

function Trending_Table() {
  const RowHeader = [
    "Product ID",
    "Status",
    "Product Name",
    "Product Categories",
    "Product HSN Code ",
    "Assigned to",
    "Tags",
    "Actions",
    "Tags",

  ];
const path="/admin-dashboard/save-product"

  return (
    <div>
      <Container>
        <Title showImport={false}>Trending Products</Title>
        <Header>
          <HeaderTitle>
            <HeaderIconLeft>
              <InputSearch />
              <PickColumn />
            </HeaderIconLeft>
            <HeaderIconRight>
              <Action />
              <Filter />
              <AddGroup />
              <CreatedOn />
            </HeaderIconRight>
          </HeaderTitle>
          <TableContainer>
            <TableHeader children={RowHeader} />
            <TableBody
              rows={osplist}
              // isLoading={isLoading}
              // error={error}
                path={path}
            />
          </TableContainer>
        </Header>
      </Container>
    </div>
  );
}
